<template>
  <div class="home">
    <div class="hero-section">
      <div class="content">
        <p class="banner-title">PDF转Word<br />表格还原准确率99.2%</p>
        <span class="divider-line"></span>
        <p class="one">
          在线OCR文字识别，扫描件一键转word，保留原表格结构，告别手动排版
        </p>
        <button @click="getPDF('ocr')" class="process-btn">
          立即免费处理 →
        </button>
        <p class="two">支持PDF扫描件，文件大小无限制</p>
      </div>
      <div class="image-container">
        <img :src="banner" alt="OCR Illustration" />
      </div>
    </div>

    <div class="features-section">
      <div class="feature-card">
        <div class="text-content">
          <h2>表格无损转换</h2>
          <p>
            智能识别表格边框、行列结构，还原度≥99.2%<br />支持跨页表格自动拼接<br />
            基于OCR+AI表格解析引擎<br />我们比传统工具更懂表格逻辑
          </p>
          <button @click="getPDF('table')" class="process-btn">
            立即免费处理 →
          </button>
        </div>
        <div class="image-container">
          <img :src="table" alt="扫描件转Word" />
        </div>
      </div>

      <div class="feature-card reverse">
        <div class="image-container">
          <img :src="ocr" alt="OCR文字识别" />
        </div>
        <div class="text-content">
          <h2>在线OCR文字识别</h2>
          <p>
            自动识别扫描件中的印刷/手写文字<br />0.3°曲面矫正 支持中英文混排<br />保留原始段落结构<br />99.9%识别准确率，告别乱码
          </p>
          <button @click="getPDF('ocr')" class="process-btn">
            立即免费处理 →
          </button>
        </div>
      </div>
    </div>

    <div class="price-section">
      <p class="title">价格方案</p>
      <div class="container">
        <div class="one">
          <img src="@/assets/home/home_icon_refuse@2x.png" alt="" />
          <p class="sub-title">拒绝隐性消费、精准降本</p>
          <p class="sub-desc">
            传统订阅模式下，90%用户年均使用不足10次。Scan2word采用按次付费机制，单次成本直降80%，无自动续费，支出透明可控。
          </p>
        </div>
        <div class="two">
          <p class="sub-title">Scan2Word</p>
          <div class="sub-desc">享受Scan2Word全部权益</div>
          <div class="price">
            <span class="price">0.1</span>
            <span class="price-unit">元/页</span>
          </div>
          <button
            class="upload-btn"
            @click="
              () => {
                router.push('/convert-scans-to-editable-docs?type=ocr');
              }
            "
          >
            立即上传
          </button>
        </div>
        <div class="three">
          <img src="@/assets/home/home_icon_mon@2x.png" alt="" />
          <p class="sub-title">按次计费、无订阅捆绑</p>
          <p class="sub-desc">
            Scan2word单次转换低至0.1元/页，支持学生论文、商务合同、学术报告等多场景，按需使用、无需订阅捆绑。
          </p>
        </div>
      </div>
    </div>

    <div class="vs">
      <div class="title">
        <p class="scan2word">Scan2Word</p>
        <img src="@/assets/home/vs.png" alt="vs" class="vs-icon" />
        <p class="others">其它工具</p>
      </div>

      <img
        src="@/assets/home/vs-detail.png"
        alt="scan2word"
        class="vs-detail-icon"
      />
    </div>

    <div class="reviews-section">
      <p class="comment-title">高度好评的OCR内容提取工具</p>
      <p class="comment-desc">
        横版、竖版文件的高质量内容提取，精准、公式也可一键转换
      </p>

      <p class="rating-desc">基于557610人的评分</p>
      <p class="rating">
        4.89<span class="rating-total">（满分5分）</span> ⭐ ⭐ ⭐ ⭐ ⭐
      </p>

      <swiper
        :slidesPerView="4"
        :centeredSlides="false"
        :spaceBetween="35"
        :loop="true"
        effect="slide"
        :speed="3000"
        :allowTouchMove="false"
        :autoplay="{
          delay: 0,
          disableOnInteraction: false,
        }"
        :modules="[Autoplay]"
        class="reviews"
      >
        <swiper-slide
          v-for="(review, index) in reviews"
          :key="index"
          class="review-card"
        >
          <div class="image-container">
            <img :src="review.avatar" alt="用户头像" class="avatar" />
            <img src="@/assets/home_icon_com@2x.png" alt="引号" class="quote" />
          </div>
          <p class="review-author">{{ review.author }}</p>
          <p class="review-job">{{ review.job }}</p>
          <p class="review-comment">{{ review.comment }}</p>
        </swiper-slide>
      </swiper>
    </div>

    <my-footer />
    <el-upload
      ref="uploadRef"
      :auto-upload="false"
      :show-file-list="false"
      accept=".pdf, .png, .jpg"
      name="file"
      v-show="false"
      :on-change="handleChange"
    >
    </el-upload>
  </div>
</template>

<script setup>
const reviews = [
  {
    avatar: require("@/assets/review/liuzhuguan.png"),
    comment: "报关单扫描件转Word格式零错位,海外客户终于不投诉了。",
    job: "10年外贸跟单经验",
    author: "刘主管",
  },
  {
    avatar: require("@/assets/review/xienvshi.png"),
    comment: "供应商报价单转换后列宽精确到毫米级,比手动制表还工整。",
    job: "百年制造企业采购经理",
    author: "谢女士",
  },
  {
    avatar: require("@/assets/review/wangxiansheng.png"),
    comment: "合同的表格格式100%还原,终于不用手动调整了!",
    job: "财务经理",
    author: "王先生",
  },
  {
    avatar: require("@/assets/review/linvshi.png"),
    comment: "文字精准无误,不用再手动录入!",
    job: "翻译工作者",
    author: "李女士",
  },
  {
    avatar: require("@/assets/review/wanglaoshi.png"),
    comment: "教材里的跨栏表格转换后自动生成可编辑题库,备课时间减半",
    job: "省级特级教师",
    author: "王老师",
  },
  {
    avatar: require("@/assets/review/lixiansheng.png"),
    comment: "转换完体验太棒了!还可以随时查找,很方便!",
    job: "汽车销售",
    author: "李先生",
  },
  {
    avatar: require("@/assets/review/lizhuguan.png"),
    comment:
      "用过最快的PDF转Word工具!合同里的跨页表格转换后和原版一模一样,再也不用手动调整了!",
    job: "外企财务",
    author: "李主管",
  },
  {
    avatar: require("@/assets/review/suntongxue.png"),
    comment:
      "这个OCR识别软件都给我无脑冲!我的扫描件有点模糊担心提取不好,没想到一点不差的给我提取出来了!",
    job: "学生",
    author: "孙同学",
  },
  {
    avatar: require("@/assets/review/zhaotongxue.png"),
    comment: "用它把文献OCR了,省了我大量时间!-",
    job: "研究生",
    author: "赵同学",
  },
];

import { nextTick, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import PdfUtil from "@/components/pdfUtil";
import banner from "@/assets/home/首图.png";
import table from "@/assets/home/table.gif";
import ocr from "@/assets/home/ocr.gif";
//引入Autoplay方法
import { Autoplay } from "swiper/modules";
//引入swiper,SwiperSlide组件
import { Swiper, SwiperSlide } from "swiper/vue";
// 引入组件样式
import "swiper/css";
import MyFooter from "@/views/footer/MyFooter.vue";
import { useHead } from "@vueuse/head";

useHead({
  title: "Scan2Word - OCR在线免费提取PDF/扫描件/图片内容",
  meta: [
    {
      name: "description",
      content:
        "免费PDF扫描件转Word工具！精准保留图片表格/排版，3秒极速OCR文字识别，轻松实现扫描件可编辑。无需订阅，即传即转换。",
    },
    {
      name: "keywords",
      content:
        "扫描件转Word, 在线OCR转换，OCR在线转换，OCR文字识别，OCR，ocr识别，OCR一键提取，PDF转Word, 图片内容提取，保留表格格式，保留排版，极速转换，扫描件可编辑，pdf可编辑，提取图片内容，免费提取PDF内容，OCR在线免费提取，免费提取图片内容，免费pdf扫描件转word，免费工具，scan2word",
    },
  ],
});
const router = useRouter(); // ✅ 获取 Vue Router 实例

var type = "word";
const store = useStore(); // Vuex 访问方式
const uploadRef = ref(null);
const handleChange = async (uploadFile, uploadFiles) => {
  const allowedTypes = ["application/pdf", "image/jpg", "image/png"];

  if (!allowedTypes.includes(uploadFile.raw.type)) {
    return ElMessage.error("仅支持 JPG、PNG、PDF格式");
  }

  //pdf文件页数限制
  if (uploadFile.raw.type === "application/pdf") {
    const count = await PdfUtil.getPdfPageCount(uploadFile.raw);
    console.log(count, "pdf页数");
    if (count > 50) return ElMessage.error("PDF页数不能大于50页");
  } else {
    //图片文件大小限制
    const size = uploadFile.raw.size / 1024 / 1024;
    if (size > 15) return ElMessage.error("图片大小不能大于15M");
  }

  if (uploadFile.status === "ready") {
    store.dispatch("clearStore");
    // 确保 Vuex 存储最新的文件
    store.dispatch("uploadPdfFile", uploadFile.raw);
    var path = "/pdf-to-word";
    switch (type) {
      case "ocr":
        path = "/ocr-text-extraction";
        break;
      case "table":
        path = "/table-format-conversion";
        break;
      default:
        break;
    }
    router.push({
      path: path,
    });
  }
};

// 打开文件选择对话框
const getPDF = (info) => {
  type = info;
  nextTick(() => {
    if (uploadRef.value) {
      uploadRef.value?.clearFiles(); // 关键：先清空文件列表
      const inputEl = uploadRef.value.$el.querySelector("input");
      if (inputEl) {
        inputEl.value = ""; // **强制清空 input 选中的文件**
        inputEl.click();
      } else {
        console.error("无法找到 input 元素");
      }
    } else {
      console.error("uploadRef 为空");
    }
  });
};
</script>

<style lang="less" scoped>
.home {
  margin-top: 88px;
}

.hero-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url("@/assets/banner.png") no-repeat center center;
  padding-left: 180px;
  height: 812px;

  .content {
    .banner-title {
      font-size: 54px;
      font-weight: bold;
      color: #222;
    }

    .divider-line {
      display: block;
      width: 60px;
      height: 8px;
      background-color: #222;
      margin: 30px 0;
    }

    .one {
      font-size: 20px;
      font-weight: normal;
      margin-top: 10px;
      color: #222;
    }

    .process-btn {
      width: 300px;
      height: 80px;
      margin-top: 50px;
      background-color: #2b79f7;
      color: #fff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      font-size: 24px;
    }

    .two {
      width: 300px;
      text-align: center;
      font-size: 16px;
      font-weight: normal;
      margin-top: 10px;
      color: #222;
    }
  }

  .image-container {
    width: 860px;
    height: 616px;
    padding-right: 152px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.features-section {
  display: flex;
  flex-direction: column;
  background-color: #f4f8ff;

  .feature-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 240px;
    height: 600px;
    border-color: #fff;

    &.reverse {
      background: #fff;
    }

    .text-content {
      h2 {
        font-size: 54px;
        font-weight: bold;
        color: #222;
      }

      p {
        font-size: 24px;
        margin-top: 24px;
        color: #222;
      }

      .process-btn {
        width: 300px;
        height: 80px;
        margin-top: 36px;
        background-color: #2b79f7;
        color: #fff;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 24px;
      }
    }

    .image-container {
      width: 612px;
      height: 412px;
      img {
        width: 100%;
      }
    }
  }
}

.price-section {
  height: 712px;
  background-color: #f4f8ff;
  padding-top: 80px;

  .title {
    font-weight: bold;
    font-size: 38px;
    color: #222;
    text-align: center;
    margin: 0;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    margin-top: 60px;

    .one,
    .three {
      width: 400px;
      height: 380px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid #ebebeb;

      img {
        margin-top: 60px;
        width: 58px;
        height: 58px;
      }

      .sub-title {
        font-weight: 600;
        font-size: 28px;
        color: #222;
      }

      .sub-desc {
        font-weight: 400;
        font-size: 18px;
        color: #222;
        text-align: center;
        margin: 0 30px;
      }
    }

    .one {
      border-radius: 16px 0 0 16px;
    }

    .three {
      border-radius: 0px 16px 16px 0px;
    }

    .two {
      width: 400px;
      height: 440px;
      background: linear-gradient(180deg, #edf4ff 0%, #bcd6ff 100%);
      box-shadow: 0px 8px 20px 0px rgba(6, 52, 126, 0.2);
      border-radius: 16px;
      border: 1px solid #ebebeb;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .sub-title {
        font-weight: bold;
        font-size: 34px;
        color: #222222;
        margin: 0px;
      }

      .sub-desc {
        font-weight: 400;
        font-size: 18px;
        color: #222222;
        margin-top: 20px;
      }

      .price {
        background-color: #fff;
        width: 200px;
        height: 82px;
        font-size: 46px;
        font-weight: bold;
        color: #2b79f7;
        border-radius: 41px;
        text-align: center;
        line-height: 82px;
        margin-top: 26px;

        .price-unit {
          font-size: 18px;
        }
      }

      .upload-btn {
        width: 300px;
        height: 80px;
        background-color: #2b79f7;
        border-radius: 8px;
        border: none;
        margin-top: 36px;
        color: #fff;
        font-weight: 500;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
}

.vs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    font-weight: normal;
    font-size: 38px;
    color: #222222;
    display: flex;
    justify-content: center;
    font-weight: bold;
    margin-top: 80px;
    align-items: center;
    .vs-icon {
      width: 70px;
      height: 72px;
      margin: 0 16px;
    }
  }

  .vs-detail-icon {
    width: 1094px;
    margin-top: 38px;
    margin-bottom: 50px;
  }
}

.reviews-section {
  background: url("@/assets/comment.png") no-repeat center center;
  padding: 40px;
  border-radius: 12px;
  text-align: center;

  .comment-title {
    font-weight: bold;
    font-size: 38px;
    color: #222222;
    margin-top: 80px;
  }

  .comment-desc {
    font-weight: normal;
    font-size: 24px;
    color: #222222;
    margin-top: 16px;
  }

  .rating-desc {
    font-weight: 400;
    font-size: 18px;
    color: #222;
    margin-top: 30px;
  }

  .rating {
    font-weight: bold;
    font-size: 18px;
    color: #222;
    margin-top: 12px;

    .rating-total {
      color: #666;
      font-size: 18px;
    }
  }

  .reviews {
    overflow-x: auto; /* 添加这一行 */
    display: flex;
    justify-content: left;
    gap: 60px;
    margin-top: 80px;
    padding-bottom: 60px;

    &::-webkit-scrollbar {
      display: none;
    }

    .review-card {
      display: inline-block;
      flex-shrink: 0;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
      text-align: left;
      width: 440px;
      height: 340px;

      .image-container {
        display: flex;
        margin: 40px;
        justify-content: space-between;
        align-items: center;

        .avatar {
          width: 66px;
          height: 66px;
          border-radius: 50%;
        }

        .quote {
          width: 28px;
          height: 28px;
        }
      }

      .review-author {
        font-weight: 600;
        font-size: 20px;
        color: #222;
        font-style: normal;
        margin: 10px 0 0 40px;
      }

      .review-job {
        font-weight: normal;
        font-size: 16px;
        color: #666;
        font-style: normal;
        margin: 10px 0 0 40px;
      }

      .review-comment {
        font-weight: normal;
        font-size: 16px;
        color: #222222;
        font-style: normal;
        margin: 16px 40px 0 40px;
      }
    }
  }
}
</style>